import { Component, inject, input, output, LOCALE_ID, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-history-stock-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './history-stock-table-component.html',
    styleUrl: './history-stock-table-component.scss',
})
export class HistoryStockTableComponent {
readonly mockData: any[] = [
  {
    id: 1,
    product: { id: 1, titleEn: 'Augmentin 1gm 14 Tab', titleAr: 'أوجمنتين 1 جم 14 قرص' },
    stockType: { titleEn: 'Incoming', titleAr: 'وارد مخزني' },
    mfgDate: '2024-10-01',
    expDate: '2026-10-01',
    batchNumber: 'AUG-9921',
    supplier: { titleEn: 'United Pharmacists', titleAr: 'المتحدة للصيادلة' },
    sellerPrice: 85.50, 
    sellerPriceDiscountPercentage: 2, 
    pharmacyPrice: 89.70, 
    pharmacyPriceDiscountPercentage: null,
    peoplePrice: 115.00, 
    quantity: 100,
    createdBy: { fullName: 'Ahmed Hassan' },
    createdOn: '2025-04-01T10:30:00',
  },
  {
    id: 2,
    product: { id: 2, titleEn: 'Panadol Advance', titleAr: 'بانادول أدقانس' },
    stockType: { titleEn: 'Stock Out', titleAr: 'صرف مخزني' },
    mfgDate: '2023-05-01',
    expDate: '2025-05-01', 
    batchNumber: 'PAN-4402',
    supplier: null,
    sellerPrice: 22.00,
    sellerPriceDiscountPercentage: null,
    pharmacyPrice: 24.50,
    pharmacyPriceDiscountPercentage: 5,
    peoplePrice: 30.00,
    quantity: 50,
    createdBy: { fullName: 'Sara Ali' },
    createdOn: '2025-03-15T08:00:00',
  },
  {
    id: 3,
    product: { id: 3, titleEn: 'Cataflam 50mg', titleAr: 'كاتافلام 50 مجم' },
    stockType: { titleEn: 'Damaged', titleAr: 'تالف' },
    mfgDate: '2024-01-01',
    expDate: '2027-01-01',
    batchNumber: 'CAT-1108',
    supplier: { titleEn: 'Ibn Sina', titleAr: 'ابن سينا' },
    sellerPrice: 42.00,
    sellerPriceDiscountPercentage: null,
    pharmacyPrice: 45.00,
    pharmacyPriceDiscountPercentage: null,
    peoplePrice: 58.50,
    quantity: 10,
    createdBy: { fullName: 'Mohamed Omar' },
    createdOn: '2025-04-10T14:20:00',
  }
];

displayData = computed(() => this.allStockData());

  private locale = inject(LOCALE_ID);

  allStockData = input.required<any[]>();
  startItem = input.required<number>();
  totalItems = input.required<number>();
  currentPage = input.required<number>();
  itemsPerPage = input.required<number>();
  totalPages = input.required<number>();
  pageNumbers = input.required<number[]>();
  productId = input<string | null>(null);

  isAr = computed(() => this.locale.startsWith('ar'));
  currency = computed(() => this.isAr() ? 'ج.م' : 'EGP');
  discountLabel = computed(() => this.isAr() ? 'خصم' : 'Disc.');
  mfgLabel = computed(() => this.isAr() ? 'إنتاج:' : 'MFG:');
  expLabel = computed(() => this.isAr() ? 'إنتهاء:' : 'EXP:');

  previousPage = output<void>();
  nextPage = output<void>();
  goToPage = output<number>();
  pageSizeChange = output<number>();

  mathMin = Math.min;

  getStartItem = computed(() => ((this.currentPage() - 1) * this.itemsPerPage()) + 1);
  getEndItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));

  getPageNumbers = computed(() => {
    const pages = [];
    const total = this.totalPages();
    const current = this.currentPage();
    
    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== -1) {
        pages.push(-1);
      }
    }
    return pages;
  });

  onPageSizeChange(event: any) {
    this.pageSizeChange.emit(Number(event.target.value));
  }

  getTranslatedTitle(item: any): string {
    return this.locale.startsWith('ar') ? item?.titleAr || item?.titleEn : item?.titleEn || item?.titleAr;
  }

   isExpired(date: string): boolean {
    return new Date(date) < new Date();
  }

  isNearExpiry(date: string): boolean {
    const expiry = new Date(date);
    const today = new Date();
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    return expiry > today && expiry <= threeMonthsFromNow;
  }

}